"use client";

import HoneyCombGallery from "./HoneyCombGallery";

export default function HoneyComb({ title, subTitle, data }) {
  return (
    <div className="bg-background-secondary xl:h-[100vh] xl:min-h-[620px] xl:max-h-[850px] xl:flex items-center overflow-hidden">
      <div className="xl:w-1/2 w-full flex items-center justify-center !py-12 md:py-16 xl:py-0 xl:h-full">
        <div className="w-full max-w-[90%] md:max-w-[85%] xl:max-w-[75%] flex flex-col items-start gap-8 md:gap-12">
          <div>
            <h2 className="text-[2.25rem] md:text-[3rem] lg:text-[3.2rem] xl:text-[3.5rem] 2xl:text-[3.8rem] leading-[1.05] font-medium tracking-[-0.04em] hero-honeycomb-subtitle">{title}</h2>
          </div>

          <div>
            <h2 className="text-[3.5rem] sm:text-[4.5rem] md:text-[5.5rem] lg:text-[6.5rem] xl:text-[7.2rem] 2xl:text-[9.5rem] leading-[0.95] font-normal tracking-[-0.04em] hero-honeycomb-title">
              {subTitle}
            </h2>
          </div>
        </div>
      </div>

      <div className="xl:w-1/2 w-full relative md:h-[80vh] xl:h-full flex items-center justify-center overflow-hidden !py-4  xl:py-0!">
        <div className="w-full h-full flex items-center justify-center relative">
          <div className="w-[100%] md:w-[85%] lg:w-[80%] xl:w-full max-w-[620px] mx-auto">
            <HoneyCombGallery data={data} />
          </div>
        </div>
      </div>
    </div>
  );
}
